import { Component, OnInit, EventEmitter, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-ean13-filter',
  templateUrl: './ean13-filter.component.html',
  styleUrls: ['./ean13-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Ean13FilterComponent),
      multi: true
    }
  ]
})
export class Ean13FilterComponent implements OnInit {
  ean13: string;
  @Output() confirmNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() quitNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  confirm() {
    this.confirmNotify.emit({ q: { field: 'ean13', value: this.ean13, regex: true }, t: { k: 'EAN13', v: this.ean13, l: 'ean-13' } });
  }

  enter(e) {
    if (e) e.preventDefault();

    if (this.ean13) {
      this.confirm()
    }
  }

  quit() {
    this.quitNotify.emit();
  }

  ngOnInit() {
  }

  private propagateChange = (_: any) => { };

  public writeValue(s: string) {
    this.ean13 = s;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/helpers/filters/ean13-filter/ean13-filter.component.ts